import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../types/analytics';
import { ILowRateMortgagePromo } from '../../../types/promosPage';
import { IPage } from '../../../types/redux';

interface ITrackPromoShowParams {
  page: IPage;
  position: number;
  promo: ILowRateMortgagePromo;
}

export const trackPromoShow = ({ page, position, promo }: ITrackPromoShowParams) => {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'Promo',
    name: 'oldevent',
    label: 'low_mortgage_rates',
    page: {
      ...page,
      extra: {
        block: EPageBlock.LowMortgageRates,
        builder_id: promo.builderId,
        Promo_id: promo.providerPromoId,
        position,
      },
    },
  });
};
